import { Text, TextDescriptionVariant } from './index'

// TODO: remove this function and directly import Text and TextDescriptionVariant in components
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getPlatformSpecificText = (isWeb: boolean) => {
  return {
    Text: Text,
    TextDescriptionVariant,
  }
}
